const messages = {
  ru: {
    goBack: 'Назад',
    copy: 'Скопировать',
    copied: 'Скопировано!',
    copyLink: 'Скопировать ссылку',
    linkCopied: 'Ссылка скопирована',
    cancel: 'Отмена',
    share: 'Поделиться',
    done: 'Готово',
    reset: 'Сбросить',
    close: 'Закрыть',
    clear: 'Очистить',
    loading: 'Загрузка...',
    loadMore: 'Загрузить ещё',
    showMore: 'Показать ещё',
    blankFieldError: 'Поле не может быть пустым',
    okay: 'Понятно',
    today: 'Сегодня',
    yesterday: 'Вчера',
    tableOfContents: 'Содержание',
    all: 'Все',
    calculatorNote:
      'Точный расчет процентной ставки вклада можно узнать в приложении TBC UZ',
    a11y: {
      fontSize: 'Размер шрифта:',
      disable: 'Выключить',
      disableShort: 'Выкл.',
    },

    navigation: {
      main: 'Главная навигация',
      sub: 'Навигация второго уровня',
      product: 'Навигация по продукту',
      home: 'На главную',
      footer: 'Нижняя навигация',
      usefulLinks: 'Полезные ссылки',
    },
    appFooter: {
      mobileAppSection: {
        appStoreLinkAriaLabel: 'Приложение в App Store',
        googlePlayLinkAriaLabel: 'Приложение в Google Play',
        appStoreBadgeAlt: 'Скачать в App Store',
        googlePlayBadgeAlt: 'Скачать в Google Play',
      },
    },
    appHeader: {
      open: 'Открыть меню',
      close: 'Закрыть меню',
      search: 'Поиск',
      openSearch: 'Открыть поиск',
      openA11yMenu: 'Открыть настройки размера текста',
      closeA11yMenu: 'Закрыть настройки размера текста',
    },
    appHeaderSearch: {
      inputPlaceholder: 'Что хотите найти?',
      frequentRequests: 'Частые запросы',
      popularProducts: 'Популярные продукты',
      notFound: 'Мы ничего не нашли',
      tryAnother: 'Попробуйте другие популярные запросы',
    },
    baseCarousel: {
      previous: 'Предыдущие элементы',
      next: 'Следующие элементы',
      pagination: 'Переместиться к элементам на слайде номер {slide}',
    },
    baseFileInput: {
      title: 'Перетащите или загрузите файл',
      allowedFormat: 'Допустимый формат: jpg, jpeg, png или pdf',
      addFile: 'Добавить файл',
    },
    basePhoneNumberInput: {
      label: 'Номер телефона',
    },
    baseLanguageSwitch: {
      switchToUZ: 'Переключиться на узбекский язык',
      switchToRU: 'Переключиться на русский язык',
      switchToEN: 'Переключиться на английский язык',
    },
    baseBottomSheet: {
      dragToResize: 'Перетащите, чтобы изменить размер',
    },
    requestForm: {
      title: 'Виртуальная приемная',
      description:
        'Заполните форму и оставьте ваш вопрос, мы ответим в ближайшее время',

      tabs: {
        title: 'Кто подает заявление',
        note: 'Обращение рассматривается согласно Закону Республики Узбекистан «Об обращениях физических и юридических лиц»',
        individual: 'Физическое лицо',
        entrepreneur: 'Юридическое лицо',
        anonimously: 'Подать анонимно',
      },

      personalData: 'Заполните личные данные',
      firstName: 'Имя',
      lastName: 'Фамилия',
      phoneNumber: 'Телефон',
      email: 'Почта',

      describeProblem: 'Опишите проблему',
      requestTopic: 'Тема обращения',
      requestTopicDescription:
        'Если вы не нашли подходящую тему обращения нажмите «Другое» и впишите тему самостоятельно',
      city: 'Город',
      requestMessage: 'Текст обращения',

      companyInfo: 'Информация о компании',
      companyName: 'Наименование компании',
      companyNumber: 'ИНН Организации',

      anonimouslyDataTitle: 'Заполните данные (по желанию)',
      anonimouslyDataDescription:
        'Если вы хотите получить отзыв но при этом хотите сохранить анонимность укажите адрес электронной почты, который не содержит ваших личных данных',

      requestAppeal: 'Подать обращение',
      leaveAppeal: 'Оставить обращение',
      checkStatus: 'Проверить статус обращения',

      anonimouslyTopics: {
        participation: 'Участие в мошеннических схема',
        internalPolicy: 'Нарушение внутренней политики',
        discrimination: 'Дискриминация сотрудников',
        ignore: 'Игнорирование конфликтов интересов',
        other: 'Другое',
      },

      describeList: {
        firstTitle: 'Что произошло?',
        firstDescription: 'У меня есть подозрения в том, что...',
        secondTitle: 'Кто причастен к инциденту или нарушению? ',
        secondDescription: 'Укажите уровень вовлеченности',
        thirdTitle: 'Где это произошло? ',
        thirdDescription:
          'Укажите город, регион, точный адрес, название филиала',
        fourthTitle: 'Когда это произошло?',
        fourthDescription: 'Укажите время, дату и периодичность инцидента',
        fifthTitle: 'Загрузите документы или фотографии.',
        fifthDescription:
          'Если у вас есть какие-либо документы, подтверждающие инцидент, пожалуйста, загрузите их',
      },

      incidentLocation: 'Место инцидента',

      fileInputTitle: 'Добавить документы или файлы',
      mobileFileInputTitle: 'Загрузить документы или файлы',

      agreeWith: 'Согласен с',
      rules: 'Правилами обращения',

      note1: 'Нажимая кнопку “Я согласен” Вы соглашаетесь с правилами',
      note2:
        ' “Порядок рассмотрения обращений граждан и клиентов АКБ "TBC Bank" ',
      note3:
        'и заявляете, что Ваше обращение не содержит оскорблений и/или иных уничижительных, ложных, порочащих честь и достоинство сведений в адрес банка и его сотрудников. В противном случае Банк вправе не рассматривать Ваше обращение и принять установленные законом меры против Вас. Сообщая Банку сведения о третьих лицах, вы гарантируете, что являетесь владельцем этих сведений и/или имеете надлежащее разрешение и несете всю ответственность за распространение таких сведений.',

      send: 'Отправить',
    },
    checkRequestForm: {
      title: 'Проверить статус обращения',
      inputData: 'Введите данные',
      inputDataDescription:
        'Введите ID обращения из 12 цифр. Статус обращения будет отправлен на почту',
      requestID: 'ID обращения',
      email: 'Почта',
      send: 'Отправить',
    },
    locationsMap: {
      errorLoadingMap:
        'Ошибка при загрузке карты. Попробуйте обновить страницу или повторить попытку позже.',
      showMyLocation: 'Показать мое местоположение',
      zoomIn: 'Увеличить масштаб',
      zoomOut: 'Уменьшить масштаб',
      cap: {
        card: {
          office: 'Отделение',
          metro: 'Метро',
          landmark: 'Ориентир',
          photo: 'Фото',
          workingHours: {
            heading: 'Время работы',
            dayOff: 'выходной',

            mondaySaturday: 'пн-сб',
            saturdaySunday: 'сб-вс',
            mondayFriday: 'пн-пт',
            mondaySunday: 'пн-вс',
            saturday: 'сб',
            sunday: 'вс',
          },
          getDirections: 'Проложить маршрут',
          copyAddress: 'Скопировать адрес',
        },
        status: {
          monday: 'понедельника',
          sunday: 'воскресенья',
          tomorrow: 'завтра',
          card: {
            open: 'Открыто до',
            closed: 'Закрыто до',
          },
          marker: {
            open: 'Открыт до',
            closed: 'Закрыт до',
          },
        },
      },
      search: {
        title: 'Поиск',
        placeholder: 'Введите адрес или метро',
      },
    },
    search: {
      title: 'Поиск по сайту',
      popularRequests: 'Популярные запросы',
      notFound: 'Мы ничего не нашли',
      tryAnother: 'Попробуйте другие популярные запросы',
      placeholder: 'Что хотите найти?',
    },
    faq: {
      title: 'Чем мы можем помочь?',
      listTitle: 'Все темы и статьи',
      readAll: 'Читать все',
      placeholder: 'Введите свой запрос',
      frequentRequests: 'Частые запросы',
    },
    smsForm: {
      typeInNumber: 'Введите номер',
      send: 'Отправить',
      sendAgain: 'Отправить ещё раз',
    },
    currencyRateBlock: {
      label: 'Курсы валют',
      dollar: 'Доллар',
      euro: 'Евро',
      ruble: 'Рубль',
      checkAll: 'Смотреть все',
      buy: 'Купить',
      sell: 'Продать',
    },
    currencySwapBlock: {
      sum: 'Сумма',
      currency: 'Валюта',
      sellingInput: {
        desktopHeading: 'У меня есть',
        mobileLabel: 'У меня есть',
      },
      buyingInput: { desktopHeading: 'Хочу купить', mobileLabel: 'Я получу' },
      swapButtonLabel: 'Поменять валюты местами',
      relevanceNotice: 'Курс актуален на {date}',
    },
    currencyRateTableBlock: {
      heading: 'Все курсы валют',
      relevanceNotice:
        'Курс актуален на {date}. Курс может изменяться в течение дня.',
      code: 'Код',
      currency: 'Валюта обмена',
      quantity: 'Единиц',
      sell: 'Продать',
      buy: 'Купить',
      cbuRate: 'Курс ЦБ',
      showAllRates: 'Показать все валюты',
    },
    calculatorBlock: {
      chooseSum:
        'Выберите сумму от {minLimit} до {maxLimit} {currency} и срок до {n} месяцев',
      text: 'При сумме вклада {sum} сроком на {term} вы получите {percent} годовых с конечной прибылью около {result}',
      keepPercent: 'Оставлять проценты',
      keepPercentDescription:
        'Каждый месяц прибавляем проценты к основной сумме вклада',
      replenishmentDeposit: 'Пополнение вкладa',
      replenishmentDepositDescription:
        'Будет доступно в любой момент после открытия вклада',
      withdrawal: 'Снятие',
      withdrawalDescription:
        'Будет доступно в любой момент после открытия вклада',
      openDeposit: 'Открыть вклад',
      months: '{n} месяцев | {n} месяц | {n} месяца | {n} месяцев',
      monthsMobile: '{n} мес.',
      som: 'СУМ',
      dollars: 'ДОЛЛАРОВ',
      schedule: {
        title: 'График выплат по вкладу',
        date: 'Дата',
        amount: 'Сумма вклада',
        percent: 'Начисленные %',
        showAllLines: 'Посмотреть все строки',
        download: 'Скачать календарь',
        total: 'Итого',
        month: '{n} месяц',
      },
    },
    creditCalculatorBlock: {
      chooseSum:
        'Выберите сумму от {minLimit} до {maxLimit} {currency} и срок до {n} месяцев',
      text: 'С желаемой суммой {sum} {currency} сроком на {months} со ставкой {rate} ежемесячный платеж составит примерно {result}',
      getCredit: 'Получить кредит',
      months: '{n} месяцев | {n} месяц | {n} месяца | {n} месяцев',
      schedule: {
        title: 'График платежей',
        date: 'Дата',
        balance: 'Остаток',
        interest: 'Проценты',
        repaidAmount: 'Погашено',
        payment: 'Платеж',
        button: 'Смотреть график платежей',
      },
    },
    creditInformation: {
      title: 'Информационный лист',
      subtitle: 'об основных условиях кредита',
      bankNameLabel: 'Наименование банка',
      bankName: 'АКБ "TBC Bank"',
      websiteLabel: 'Веб-сайт',
      phoneNumberLabel: 'Номер телефона',
      label1: 'Сведения по кредиту',
      label2: 'Другие значимые условия',
      label3: 'Ознакомьтесь перед согласием на получение микрозайма',
      gracePeriodLabel: 'Льготный период',
      reviewPeriodText: 'Не более одного дня',
      reviewPeriodLabel: 'Срок рассмотрения заявки',
      paymentPeriodLabel: 'Периодичность платежей',
      paymentPeriodText: 'Ежемесячно',
      paymentMethodLabel: 'Способ погашения',
      paymentMethodText: 'Ануитентный',
      methodLabel: 'Способ предоставления',
      methodText:
        'Зачисление на счёт до востребования, открытый в Банке, на банковскую карту, эмитированную Банком',
      additionalCostsLabel: 'Дополнительные расходы',
      loanTypeLabel: 'Вид кредита',
      loanTypeText: 'Микрозайм',
      loanPurposeLabel: 'Цель кредита',
      loanPurposeText: 'Личные нужды',
      loanAmountLabel: 'Сумма кредита',
      loanTermLabel: 'Срок кредита',
      loanRateLabel: 'Процентная ставка',
      loanOverpaymentLabel: 'Сумма переплаты',
      loanPaymentLabel: 'Ежемесячный платеж',
      loanTotalAmountLabel: 'Общая сумма к оплате',
      som: '{n} сум',
      months: '{n} месяцев | {n} месяц | {n} месяца | {n} месяцев',
      notAvailable: 'Не имеется',
      note: 'Данная форма не заменяет кредитный договор или заявку на кредит, а скорее помогает вам сравнить условия кредитования разных банков и сделать правильный выбор.',
      page: 'Стр. {n}/2',
      penalty: 'Штраф за единоразовую просрочку платежа в размере:',
      penalty1:
        'При регулярном месячном платеже до 500 000 не включительно: 50 000 сум;',
      penalty2:
        'При регулярном месячном платеже до 1,000,000 не включительно: 75,000 сум;',
      penalty3:
        'При регулярном месячном платеже от 1,000,000 включительно: 100,000 сум.',
      penaltyEnd:
        'Банк вправе требовать от Заемщика досрочное погашение онлайн-микрозайма (с учетом начисленных процентов) в соответствии с Кредитным Договором.',
      additionalPercent:
        'Повышенный процент — 0,5% в день от суммы просроченного долга',
      collateralForLoan: 'Обеспечение кредита отсутствует',
      lifeInsurance:
        'Если клиент решит приобрести страхование жизни (добровольное), оплата страховой премии будет произведена из кредитных средств',
      rights:
        'Вы имеете право получить от банка полную и подробную информацию об условиях и стоимости кредита, порядке платежей и расчетов (проценты, штрафы и пени), ваших правах и обязанностях по кредитному договору, рисках и ответственности, которые могут возникнуть по кредитному договору, а также по другим непонятным вам вопросам.',
      contacts:
        'Если у Вас возникли какие-либо жалобы, вы можете направить свой запрос по электронной почте на адрес +998 78 777 27 27 или на адрес (100015), г. Ташкент, Мирабадский район, улица Фидокор 10Б или на адрес {email}',
    },
    creditCalculatorFormBlock: {
      label1: 'Если вы возьмёте кредит на сумму',
      label2: 'на срок со ставкой',
      label3: 'ежемесячный платеж составит:',
      button: 'Подать заявку',
      downloadInfoList: 'Скачать информационный лист',
      max: 'Макс {n}',
      rate: 'Ставка',
      creditTerm: 'Срок кредита',
      months: '{n} месяцев | {n} месяц | {n} месяца | {n} месяцев',
      years: '{n} лет | {n} год | {n} года | {n} лет',
    },
    tenderListBlock: {
      sort: 'Сортировать',
      year: '{n} год',
      submissionDate: 'Подача заявок до {date}',
      asc: 'Сначала старые',
      desc: 'Сначала новые',
    },
    tenderRequestForm: {
      label: 'Оставить заявку',
      firstName: 'Имя',
      lastName: 'Фамилия',
      phoneNumber: 'Номер телефона',
      email: 'Почта',
      extraInfo: 'Дополнительные сведения',
      send: 'Отправить',
      agreements:
        'Я соглашаюсь передать свои персональные данные, содержащиеся в анкете и всех приложенных файлах. Я понимаю и соглашаюсь, что мои данные будут храниться и обрабатываться.',
      mustAgree: 'Нужно согласиться с условиями',
      personalData: 'Заполните личные данные',
      agreementsMobile: 'Согласен с {rules}',
      rules: 'Правилами обращения',
    },
    depositCalculatorFormBlock: {
      label1: 'Если вы откроете',
      label2: 'на срок',
      label3: 'и вложите',
      label4: 'ваш доход составит',
      open: 'Открыть {text}',
      max: 'макс',
      keepPercent: 'Оставлять проценты',
      month: '{n} мес.',
      keepPercentDescription:
        'Каждый месяц прибавляем проценты к основной сумме вклада',
      replenishmentDeposit: 'Пополнение вкладa',
      replenishmentDepositDescription:
        'Будет доступно в любой момент после открытия вклада',
      withdrawal: 'Частичное снятие',
      withdrawalDescription:
        'Будет доступно в любой момент после открытия вклада',
      year: 'годовых',
      schedule: 'Смотреть график выплат',
      tooltipCapitalization: {
        title: 'Что значит оставлять проценты',
        description:
          'Каждый месяц проценты прибавляются к вкладу — его сумма растёт, а значит, в следующем месяце проценты начисляются уже на увеличенную сумму.',
      },
      tooltipWithdrawal: {
        title: 'Что значит частичное снятие',
        description:
          'Сумма вклада уменьшается на сумму снятия, однако проценты продолжают начисляться по той же ставке, которая была на начало депозита.',
      },
    },
    blog: {
      readingTime: '{n} мин чтения',
      openArticle: 'Открыть статью',
      openTagArticles: 'Открыть статьи по тегу',
      showAllTags: 'Показать все теги',
      viewAllArticles: 'Смотреть все статьи',
      allArticles: 'Все статьи',
      toHomePage: 'На главную блога',
      tagPageHeading: 'Все статьи по тегу «{tag}»',
    },
    mediaPlayer: {
      play: 'Воспроизвести',
      pause: 'Пауза',
      mute: 'Выключить звук',
      unmute: 'Включить звук',
      fullscreen: 'Полноэкранный режим',
      exitFullscreen: 'Выйти из полноэкранного режима',
    },
    career: {
      vacancies: '{n} вакансий | {n} вакансия | {n} вакансии | {n} вакансий',
      allVacancies: 'Все вакансии',
    },
    vacancies: {
      searchPlaceholder: 'Введите название должности',
      area: 'Локация',
      workExperience: 'Опыт работы',
      experience: 'Опыт',
      categories: 'Направления',
      workExperienceOptions: {
        noExperience: 'Без опыта',
        between1And3: 'От 1 до 3 лет',
        between3And6: 'От 3 до 6 лет',
        moreThan6: 'Более 6 лет',
      },
      workFormats: {
        hybrid: 'Гибрид',
        onsite: 'Офис',
        remote: 'Удаленно',
        field: 'Выездной',
      },
      openVacancy: 'Открыть вакансию',
    },
    vacanciesBlock: {
      title: 'Вакансии',
      allCategories: 'Все направления',
      showMoreVacancies: 'Показать ещё вакансии',
    },
    mobileVacanciesBlock: {
      title: 'Все вакансии\n в TBC UZ',
    },
    interestFreePaymentCalculatorBlock: {
      dateOfPurchase: 'Дата покупки',
      paymentPeriod: 'Платежный период',
      percentFree: 'Без процентов ',
      percentFreeDays: 'дней',
      note: 'Оплатить задолженность можно в любой из дней платежного периода',
    },
    months: {
      january: 'января',
      february: 'февраля',
      martha: 'марта',
      april: 'апреля',
      may: 'мая',
      june: 'июня',
      july: 'июля',
      august: 'августа',
      september: 'сентября',
      october: 'октября',
      november: 'ноября',
      december: 'декабря',
      januaryShort: 'янв',
      februaryShort: 'фев',
      marthaShort: 'мар',
      aprilShort: 'апр',
      mayShort: 'мая',
      juneShort: 'июн',
      julyShort: 'июл',
      augustShort: 'авг',
      septemberShort: 'сен',
      octoberShort: 'окт',
      novemberShort: 'ноя',
      decemberShort: 'дек',
    },
    newsListBlock: {
      allNews: 'Все новости',
      asc: 'Сначала старые',
      desc: 'Сначала новые',
    },
    NewsOtherArticlesBlock: {
      otherNews: 'Другие новости',
    },

    tags: 'Теги',
  },
  uz: {
    goBack: 'Orqaga',
    copy: 'Nusxalash',
    copied: 'Ko‘chirildi!',
    copyLink: 'Havolani nusxalash',
    linkCopied: 'Havola nusxalandi',
    cancel: 'Bekor qilish',
    share: 'Ulashish',
    done: 'Yakunlash',
    reset: 'Toza',
    close: 'Yopish',
    clear: 'Toza',
    loadMore: 'Yuklash',
    showMore: 'Ko‘proq ko‘rsatish',
    loading: 'Yuklanmoqda...',
    blankFieldError: 'Maydon boʻsh boʻlishi mumkin emas',
    today: 'Bugun',
    yesterday: 'Kecha',
    tableOfContents: 'Mavjudlik',
    all: 'Barcha',
    calculatorNote:
      'Toʻgʻri foiz stavkasini kredit kalkulyatorida koʻrishingiz mumkin',
    okay: 'Tushungan',
    a11y: {
      fontSize: 'Shrift hajmi:',
      disable: 'O‘chirib qo‘yish',
      disableShort: 'O‘chirilgan',
    },

    navigation: {
      main: 'Asosiy navigatsiya',
      sub: 'Ikkinchi daraja navigatsiyasi',
      product: 'Mahsulot navigatsiyasi',
      home: 'Bosh sahifaga',
      footer: 'Pastki navigatsiya',
      usefulLinks: 'Foydali havolalar',
    },
    appFooter: {
      mobileAppSection: {
        appStoreLinkAriaLabel: "App Store'dagi ilova",
        googlePlayLinkAriaLabel: "Google Play'dagi ilova",
        appStoreBadgeAlt: "App Store'dan yuklab olish",
        googlePlayBadgeAlt: "Google Play'dan yuklab olish",
      },
    },
    appHeader: {
      open: 'Menyuni ochish',
      close: 'Menyuni yopish',
      search: 'Qidirish',
      openSearch: 'Qidiruvni ochish',
      openA11yMenu: 'Matn o‘lchamini sozlashni ochish',
      closeA11yMenu: 'Matn o‘lchamini sozlashni yopish',
    },
    appHeaderSearch: {
      inputPlaceholder: 'Nimani topmoqchisiz?',
      frequentRequests: 'Tez-tez so‘rovlar',
      popularProducts: 'Ommabop mahsulotlar',
      notFound: 'Hech narsa topmadik',
      tryAnother: 'Boshqa mashhur so‘rovlarni sinab ko‘ring',
    },
    baseCarousel: {
      previous: 'Əvvəlki elementlər',
      next: 'Növbəti elementlər',
      pagination: 'Slayd nömrəsi {slide} üzrə elementlərə keçid',
    },
    baseFileInput: {
      title: 'Faylni torting yoki yuklang',
      allowedFormat: 'Yaroqli format: jpg, jpeg, png yoki pdf',
      addFile: 'Fayl qo‘shish',
    },
    basePhoneNumberInput: {
      label: 'Telefon raqami',
    },
    baseLanguageSwitch: {
      switchToUZ: "O'zbek tiliga o'tish",
      switchToRU: "Rus tiliga o'tish",
      switchToEN: "Ingliz tiliga o'tish",
    },
    baseBottomSheet: {
      dragToResize: 'Oʻlchamini oʻzgartirish uchun torting',
    },
    requestForm: {
      title: 'Virtual qabulxona',
      description:
        'Shaklni toʻldiring va savolingizni qoldiring, biz imkon qadar tezroq javob beramiz',

      tabs: {
        title: 'Kim murojaat qilmoqda',
        note: 'Murojaat “Jismoniy va yuridik shaxslarning murojaatlari to‘g‘risida”gi O‘zbekiston Respublikasi Qonuniga muvofiq ko‘rib chiqiladi.',
        individual: 'Individual',
        entrepreneur: 'Yuridik shaxs',
        anonimously: 'Anonim tarzda yuboring',
      },

      personalData: 'Shaxsiy ma‘lumotlaringizni to‘ldiring',
      firstName: 'Ism',
      lastName: 'Familiya',
      phoneNumber: 'Telefon',
      email: 'Pochta',

      describeProblem: 'Muammoni tasvirlab bering',
      requestTopic: 'Apellyatsiya mavzusi',
      requestTopicDescription:
        'Agar so‘rovingiz uchun mos mavzuni topmagan bo‘lsangiz, "Boshqa" tugmasini bosing va mavzuni o‘zingiz kiriting',
      city: 'Shahar',
      requestMessage: 'Murojaat matni',

      companyInfo: 'Kompaniya haqida ma‘lumot',
      companyName: 'Shirkat nomi',
      companyNumber: 'Tashkilotning STIR',

      anonimouslyDataTitle: 'Tafsilotlarni to‘ldiring (ixtiyoriy)',
      anonimouslyDataDescription:
        'Agar siz fikr-mulohaza olishni istasangiz, lekin anonim qolishni istasangiz, shaxsiy ma‘lumotlaringizni o‘z ichiga olmagan elektron pochta manzilini ko‘rsating.',

      requestAppeal: 'Shikoyat yuboring',
      leaveAppeal: 'So‘rov qoldiring',
      checkStatus: 'So‘rov holatini tekshiring',

      anonimouslyTopics: {
        participation: 'Firibgarlik sxemasida ishtirok etish',
        internalPolicy: 'Ichki siyosatni buzish',
        discrimination: 'Xodimlarga nisbatan diskriminatsiya',
        ignore: 'Manfaatlar to‘qnashuviga e‘tibor bermaslik',
        other: 'Boshqa',
      },

      describeList: {
        firstTitle: 'Nima bo‘ldi?',
        firstDescription: 'Menda shubhalar bor ...',
        secondTitle: 'Hodisa yoki huquqbuzarlikka kim aloqador? ',
        secondDescription: 'Iltimos, ishtirok darajangizni ko‘rsating',
        thirdTitle: 'U qayerda yuz berdi?',
        thirdDescription:
          'Shahar, viloyat, aniq manzil, filial nomini ko‘rsating',
        fourthTitle: 'Bu qachon sodir bo‘ldi?',
        fourthDescription:
          'Voqea sodir bo‘lgan vaqt, sana va chastotani ko‘rsating',
        fifthTitle: 'Hujjatlarni yoki fotosuratlarni yuklang.',
        fifthDescription:
          'Agar sizda voqeani tasdiqlovchi hujjatlar bo‘lsa, ularni yuklang',
      },

      incidentLocation: 'Voqea sodir bo‘lgan joy',

      fileInputTitle: 'Hujjatlar yoki fayllar qo‘shing',
      mobileFileInputTitle: 'Hujjatlar yoki fayllarni yuklash',

      agreeWith: 'Men roziman',
      rules: 'xizmat shartlariga',

      note1:
        '“Roziman” tugmasini bosish orqali siz qoidalarga rozilik bildirasiz',
      note2:
        ' “TBC Bank” ATB fuqarolar va mijozlarning murojaatlarini ko‘rib chiqish tartibi ',
      note3:
        'hamda arizangizda bank va uning xodimlariga nisbatan haqorat va/yoki boshqa kamsituvchi, yolg‘on, tuhmat qiluvchi ma’lumotlar mavjud emasligini ma’lum qiling. Aks holda, Bank sizning arizangizni ko’rib chiqmaslik va sizga nisbatan qonuniy choralar ko’rish huquqiga ega. Bankka uchinchi shaxslar to‘g‘risidagi ma’lumotlarni taqdim etish orqali siz ushbu ma’lumotlarning egasi ekanligingizga va/yoki tegishli ruxsatga ega ekanligingizga kafolat berasiz va bunday ma’lumotlarni tarqatish uchun to‘liq javobgarlikni o‘z zimmangizga olasiz.',

      send: 'Yuborish',
    },
    locationsMap: {
      errorLoadingMap:
        'Xarita yuklanishda xatolik. Iltimos, sahifani yangilang yoki keyinroq qayta urinib ko‘ring.',
      showMyLocation: 'Mening joylashuvimni ko‘rsatish',
      zoomIn: 'Masshtabni kattalashtirish',
      zoomOut: 'Masshtabni kichraytirish',
      cap: {
        card: {
          office: 'Bo‘lim',
          metro: 'Metro',
          landmark: 'Mo‘ljal',
          photo: 'Surat',
          workingHours: {
            heading: 'Ish vaqti',
            dayOff: 'dam olish kuni',

            mondaySaturday: 'du-sh',
            saturdaySunday: 'sh-yak',
            mondayFriday: 'du-juma',
            mondaySunday: 'du-yak',
            saturday: 'sh',
            sunday: 'yak',
          },
          getDirections: 'Yo‘nalishni tuzish',
          copyAddress: 'Manzilni nusxalash',
        },
        status: {
          monday: 'dushanba',
          sunday: 'yakshanba',
          tomorrow: 'ertaga',
          card: {
            open: 'Ochiqgacha',
            closed: 'Yopiqgacha',
          },
          marker: {
            open: 'Ochiqgacha',
            closed: 'Yopiqgacha',
          },
        },
      },
      search: {
        title: 'Qidirish',
        placeholder: 'Manzil yoki metroni kiriting',
      },
    },
    search: {
      title: 'Saytni qidiring',
      popularRequests: 'Ommabop so’rovlar',
      notFound: 'Hech narsa topmadik',
      tryAnother: 'Boshqa mashhur so’rovlarni sinab ko’ring',
      placeholder: 'Nimani topmoqchisiz?',
    },
    faq: {
      title: 'Biz qanday yordam bera olamiz?',
      listTitle: 'Barcha mavzular va maqolalarи',
      readAll: 'Hammasini o’qing',
      placeholder: 'So’rovingizni kiriting',
      frequentRequests: 'Tez-tez so’rovlar',
    },
    smsForm: {
      typeInNumber: 'Raqamni kiriting',
      send: 'Yuborish',
      sendAgain: 'Qayta yuborish',
    },
    currencyRateBlock: {
      label: 'Valyutalar kursi',
      dollar: 'Dollar',
      euro: 'Evro',
      ruble: 'Rubil',
      checkAll: 'Hammasini ko’rish',
      buy: 'Sotib olish',
      sell: 'Sotish',
    },
    currencySwapBlock: {
      sum: 'Summasi',
      currency: 'Valyuta',
      sellingInput: {
        desktopHeading: 'Menda bor',
        mobileLabel: 'Menda bor',
      },
      buyingInput: {
        desktopHeading: 'Sotib olmoqchiman',
        mobileLabel: 'Men olaman',
      },
      swapButtonLabel: 'Valyutalarni almashtirish',
      relevanceNotice: '{date} sanasiga nisbatan kurs',
    },
    currencyRateTableBlock: {
      heading: 'Barcha valyutalar kursi',
      relevanceNotice:
        '{date} sanasiga nisbatan kurs. Kurs kun davomida o‘zgarishi mumkin.',
      code: 'Kod',
      currency: 'Valyuta almashinuvi',
      quantity: 'Birliklar',
      sell: 'Sotish',
      buy: 'Sotib olish',
      cbuRate: 'MB kursi',
      showAllRates: 'Barcha valyutalarni ko‘rsatish',
    },
    calculatorBlock: {
      chooseSum:
        '{minLimit} dan {maxLimit} {currency} gacha bo‘lgan miqdorni va {n} oygacha muddatni tanlang',
      text: '{sum} {currency} miqdorida {term} muddatga siz yiliga {percent} olasiz va yakuniy foyda taxminan {result} bo’ladi.',
      keepPercent: 'Qiziqishni qoldiring',
      keepPercentDescription:
        'Har oy biz asosiy depozit miqdoriga foizlarni qo’shamiz',
      replenishmentDeposit: 'Depozitni to’ldirish',
      replenishmentDepositDescription:
        'Omonat ochilgandan keyin istalgan vaqtda mavjud bo’ladi',
      withdrawal: 'Olib tashlash',
      withdrawalDescription:
        'Omonat ochilgandan keyin istalgan vaqtda mavjud bo’ladi',
      openDeposit: 'Ochiq hissa',
      months: '{n} oy | {n} oy',
      monthsMobile: '{n} oy',
      som: 'SO’M',
      dollars: 'DOLLAR',
      schedule: {
        title: 'Yorliqdagi to’lov jadvali',
        date: 'Sana',
        amount: 'Depozit miqdori',
        percent: 'Hisoblangan %',
        showAllLines: 'Barcha qatorlarni ko’rsatish',
        download: 'Kalendar yuklab olish',
        total: 'Jami',
        month: '{n} oy',
      },
    },
    creditCalculatorBlock: {
      chooseSum:
        '{minLimit} dan {maxLimit} {currency} gacha bo‘lgan miqdorni va {n} oygacha muddatni tanlang',
      text: '{sum} {currency} miqdorida {months} muddatga {rate} stavka bilan oylik to‘lov taxminan {result} tashkil qiladi.',
      getCredit: 'Kredit oling',
      months: '{n} oy | {n} oy',
    },
    creditCalculatorFormBlock: {
      label1: 'Agar siz ushbu miqdor uchun kredit olsangiz',
      label2: 'stavka bilan muddatga',
      label3: 'oylik to‘lov taxminan',
      button: 'Murojaat qoldiring',
      downloadInfoList: 'Murojaatni yuklab olish',
      max: 'maks {n}',
      rate: 'stavka',
      creditTerm: 'muddat',
      months: '{n} oy | {n} oy',
      years: '{n} yil | {n} yil',
    },
    tenderListBlock: {
      sort: 'Saralash',
      year: '{n} yil',
      submissionDate: 'Arizalarni {date} yilgacha topshirish',
      asc: 'Avval eskilar',
      desc: 'Birinchi navbatda yangilari',
    },
    tenderRequestForm: {
      label: 'So‘rov qoldiring',
      firstName: 'Ism',
      lastName: 'Familiya',
      phoneNumber: 'Telefon raqami',
      email: 'E-mail',
      extraInfo: 'Batafsil ma‘lumot',
      send: 'Yuborish',
      agreements:
        'Men so‘rovnomadagi shaxsiy ma‘lumotlarimni va unga biriktirilgan barcha fayllarni uzatishga roziman. Mening ma‘lumotlarim saqlanishi va qayta ishlanishini tushunaman va roziman.',
      mustAgree: 'Siz shartlarga rozi bo‘lishingiz kerak',
      personalData: 'Shaxsiy ma‘lumotlaringizni to‘ldiring',
      agreementsMobile: 'Men {rules} roziman',
      rules: 'xizmat shartlariga',
    },
    depositCalculatorFormBlock: {
      label1: 'Agar siz',
      label2: 'muddatga',
      label3: 'va',
      label4: 'miqdorni',
      open: 'Ochiq hissa',
      max: 'maks',
      keepPercent: 'Qiziqishni qoldiring',
      month: '{n} oy',
      keepPercentDescription:
        'Har oy biz asosiy depozit miqdoriga foizlarni qo’shamiz',
      replenishmentDeposit: 'Depozitni to’ldirish',
      replenishmentDepositDescription:
        'Omonat ochilgandan keyin istalgan vaqtda mavjud bo’ladi',
      withdrawal: 'Olib tashlash',
      withdrawalDescription:
        'Omonat ochilgandan keyin istalgan vaqtda mavjud bo’ladi',
      year: 'yiliga',
      schedule: 'Yorliqdagi to‘lov jadvali',
      tooltipCapitalization: {
        title: 'Foiz qoldirish nimani anglatadi',
        description:
          'Har oy omonatga foizlar qo‘shiladi - uning miqdori o‘sib boradi, ya‘ni keyingi oyda foizlar oshgan summaga hisoblanadi.',
      },
      tooltipWithdrawal: {
        title: 'Qisman olib tashlash nimani anglatadi',
        description:
          'Omonat miqdori kamayadi, lekin foizlar asosiy depozit miqdoriga qarab hisoblanadi.',
      },
    },
    checkRequestForm: {
      title: 'So‘rov holatini tekshirish',
      inputData: 'Ma‘lumotlarni kiriting',
      inputDataDescription:
        '12 xonali so‘rov ID raqamini kiriting. So‘rov holati elektron pochtangizga yuboriladi',
      requestID: 'So‘rov ID',
      email: 'Elektron pochta',
      send: 'Yuborish',
    },
    creditInformation: {
      title: 'Kreditning asosiy shartlari to‘g‘risida axborot varaqasi',
      subtitle: '',
      bankNameLabel: 'Bank nomi',
      bankName: '«TBC BANK» ATB',
      websiteLabel: 'Bank veb-sayti',
      phoneNumberLabel: 'Bank telefon raqami',
      label1: 'Kredit bo‘yicha ma’lumotlar',
      label2: 'Moliyaviy majburiyatlar bilan bog‘liq boshqa muhim shartlar',
      label3:
        'Mikroqarz olishga rozilik berishdan oldin diqqat bilan o‘qib chiqing',
      gracePeriodLabel: 'Льготный период',
      reviewPeriodText: 'Не более одного дня',
      reviewPeriodLabel: 'Срок рассмотрения заявки',
      paymentPeriodLabel: 'To‘lovlarning davriyligi ',
      paymentPeriodText: 'Har oy ',
      paymentMethodLabel: 'Kreditni qaytarish usuli',
      paymentMethodText: 'Annuitet usuli',
      methodLabel: 'Kredit/qarz berish shakli',
      methodText:
        '“TBC Bank” ATBda ochilgan hisob raqami yoki kartaga pul o‘tkazish',
      additionalCostsLabel: 'Qo‘shimcha xarajatlar',
      loanTypeLabel: 'Kredit turi',
      loanTypeText: 'Mikroqarz',
      loanPurposeLabel: 'Kreditning maqsadi',
      loanPurposeText: 'Shaxsiy ehtiyojlar uchun',
      loanAmountLabel: 'Kredit summasi',
      loanTermLabel: 'Kredit muddati',
      loanRateLabel: 'Mikroqarzning foiz stavkasi',
      loanOverpaymentLabel: 'Сумма переплаты',
      loanPaymentLabel: 'To‘lov davrida bir martalik to‘lov summasi ',
      loanTotalAmountLabel: 'Jami barcha to‘lovlar',
      som: '{n} soʻm',
      months: '{n} oy | {n} oy',
      notAvailable: 'Mavjud emas',
      note: 'Ushbu shakl kredit shartnomasi yoki kredit arizasining o‘rnini bosmaydi, aksincha turli banklarning kreditlash shartlarini solishtirish va to‘g‘ri qaror qabul qilishingizda sizga yordam beradi.',
      page: 'Sahifa {n}/2',
      penalty: 'To‘lovni bir marta kechiktirganlik uchun jarima:',
      penalty1:
        '500 000 soʻmgacha muntazam oylik toʻlov (ya’ni 499 999 soʻm): 50 000 soʻm;',
      penalty2:
        '1 000 000 soʻmgacha muntazam oylik toʻlov (ya’ni 999 999 soʻm): 75 000 soʻm;',
      penalty3:
        '1 000 000 soʻm va undan koʻproq muntazam oylik toʻlov (1 000 000 soʻm shu jumladan): 100 000 soʻm.',
      penaltyEnd:
        'Bank Kredit shartnomasiga muvofiq Qarz oluvchidan onlayn mikroqarzni muddatidan oldin (hisoblangan foizlarni hisobga olgan holda) qaytarishni talab qilishga haqli.',
      additionalPercent:
        'Oshirilgan foiz - muddati o‘tgan asosiy qarz summasidan kuniga 0,5%',
      collateralForLoan:
        'Agar mijoz (ixtiyoriy ravishda) hayot sug‘urtasiga ega boʻlmoqchi boʻlsa, sug‘urta mukofotini to‘lash kredit mablag‘lari hisobidan amalga oshiriladi.',
      lifeInsurance:
        'Agar mijoz (ixtiyoriy ravishda) hayot sug‘urtasiga ega boʻlmoqchi boʻlsa, sug‘urta mukofotini to‘lash kredit mablag‘lari hisobidan amalga oshiriladi.',
      rights:
        'Siz Bankdan kredit shartlari va qiymati, to‘lovlar va hisob-kitoblar tartibi (foizlar, jarimalar va penyalar), kredit shartnomasi bo‘yicha huquq va majburiyatlaringiz, kredit shartnomasi bo‘yicha yuzaga kelishi mumkin bo‘lgan tavakkalchiliklar va javobgarliklar, shuningdek, sizga tushunarsiz bo‘lgan boshqa masalalar to‘g‘risida to‘liq va batafsil ma’lumot olish huquqiga egasiz.',
      contacts:
        'Siz shikoyat va murojaatlaringizni quyidagi manzillardan biriga yuborishingiz mumkin: +998 78 777 27 07 telefon raqamiga, Toshkent shahri, Mirobod tumani, Fidokor ko‘chasi, 10-B uy manziliga yoki {email} elektron pochta manziliga.',
    },
    blog: {
      readingTime: '{n} daqiqalik o‘qish',
      openArticle: 'Maqolani ochish',
      openTagArticles: "Teg bo'yicha maqolalarni ochish",
      showAllTags: "Barcha teglarni ko'rsatish",
      viewAllArticles: 'Barcha maqolalarni ko‘rsatish',
      allArticles: 'Barcha maqolalar',
      toHomePage: 'Blogga qaytish',
      tagPageHeading: 'Barcha maqolalar bo‘yicha «{tag}»',
    },
    mediaPlayer: {
      play: 'Ijro etish',
      pause: 'Pauza',
      mute: 'Ovozni o‘chirish',
      unmute: 'Ovozni yoqish',
      fullscreen: 'To‘liq ekran rejimi',
      exitFullscreen: 'To‘liq ekrandan chiqish',
    },
    career: {
      vacancies:
        '{n} ish o‘rinlari | {n} ish o‘rni | {n} ish o‘rinlari | {n} ish o‘rinlari',
      allVacancies: 'Barcha ish o‘rinlari',
    },
    vacancies: {
      searchPlaceholder: 'Lavozim nomini kiriting',
      area: 'Manzil',
      workExperience: 'Ish tajribasi',
      experience: 'Tajriba',
      categories: 'Yo‘nalishlar',
      workExperienceOptions: {
        noExperience: 'Tajriba yo‘q',
        between1And3: '1 yildan 3 yilgacha',
        between3And6: '3 yildan 6 yilgacha',
        moreThan6: '6 yildan ortiq',
      },
      workFormats: {
        hybrid: 'Gibrid',
        onsite: 'Ofisda',
        remote: 'Masofaviy',
        field: 'Sayyor',
      },
      openVacancy: 'Vakansiyani ochish',
    },
    vacanciesBlock: {
      title: 'Vakansiyalar',
      allCategories: 'Barcha yo‘nalishlar',
      showMoreVacancies: 'Yana vakansiyalarni ko‘rsatish',
    },
    mobileVacanciesBlock: {
      title: 'Barcha vakansiyalar\n TBC UZda',
    },
    interestFreePaymentCalculatorBlock: {
      dateOfPurchase: 'Xarid qilingan sana',
      paymentPeriod: "To'lov muddati",
      percentFree: 'Foizsiz',
      percentFreeDays: 'kun',
      note: "Qarzdorlikni to'lov muddatining istalgan kunida to'lashingiz mumkin",
    },
    months: {
      january: 'yanvar',
      february: 'fevral',
      martha: 'marta',
      april: 'aprel',
      may: 'may',
      june: 'iyun',
      july: 'iyul',
      august: 'avgust',
      september: 'sentyabr',
      october: 'oktyabr',
      november: 'noyabr',
      december: 'dekabr',
      januaryShort: 'yan',
      februaryShort: 'fev',
      marthaShort: 'mar',
      aprilShort: 'apr',
      mayShort: 'may',
      juneShort: 'iyun',
      julyShort: 'iyul',
      augustShort: 'avg',
      septemberShort: 'sen',
      octoberShort: 'okt',
      novemberShort: 'noy',
      decemberShort: 'dek',
    },
    newsListBlock: {
      allNews: 'Barcha yangiliklar',
      asc: 'Avval eskilar',
      desc: 'Birinchi navbatda yangilari',
    },
    NewsOtherArticlesBlock: {
      otherNews: 'Boshqa yangiliklar',
    },

    tags: 'Teglar',
  },
  en: {
    goBack: 'Back',
    copy: 'Copy',
    copied: 'Copied!',
    copyLink: 'Copy link',
    linkCopied: 'Link copied',
    cancel: 'Cancel',
    share: 'Share',
    done: 'Done',
    reset: 'Reset',
    close: 'Close',
    clear: 'Clear',
    loading: 'Loading...',
    loadMore: 'Load more',
    showMore: 'Show more',
    blankFieldError: 'This field cannot be blank',
    today: 'Today',
    yesterday: 'Yesterday',
    tableOfContents: 'Table of contents',
    all: 'All',
    calculatorNote:
      'The exact calculation of the deposit interest rate can be found in the TBC UZ application',
    okay: 'Okay',
    a11y: {
      fontSize: 'Font size:',
      disable: 'Disable',
      disableShort: 'Off',
    },

    navigation: {
      main: 'Main nanigation',
      sub: 'Second level navigation',
      product: 'Product navigation',
      home: 'Home',
      footer: 'Footer nabigation',
      usefulLinks: 'Useful links',
    },
    appFooter: {
      mobileAppSection: {
        appStoreLinkAriaLabel: 'Get app in App Store',
        googlePlayLinkAriaLabel: 'Get app in Google Play',
        appStoreBadgeAlt: 'Download app via App Store',
        googlePlayBadgeAlt: 'Download app via Google Play',
      },
    },
    appHeader: {
      open: 'Open menu',
      close: 'Close menu',
      search: 'Search',
      openSearch: 'Open search popup',
      openA11yMenu: 'Open accessibility settings',
      closeA11yMenu: 'Close accessibility settings',
    },
    appHeaderSearch: {
      inputPlaceholder: 'Search',
      frequentRequests: 'Frequent requests',
      popularProducts: 'Popular products',
      notFound: 'Мы ничего не нашли',
      tryAnother: 'Попробуйте другие популярные запросы',
    },
    baseCarousel: {
      previous: 'Previous',
      next: 'Next',
      pagination: 'Go to {slide} slide',
    },
    baseFileInput: {
      title: 'Drag&drop or download file',
      allowedFormat: 'Allowed file format: jpg, jpeg, png или pdf',
      addFile: 'Add file',
    },
    basePhoneNumberInput: {
      label: 'Phone number',
    },
    baseLanguageSwitch: {
      switchToUZ: 'Switch to Uzbek language',
      switchToRU: 'Switch to Russian language',
      switchToEN: 'Switch to English language',
    },
    baseBottomSheet: {
      dragToResize: 'Drag to resize',
    },
    requestForm: {
      title: 'Request form',
      description:
        'Fill out the form and leave your question, we will respond shortly',

      tabs: {
        title: 'Who applies',
        note: 'The appeal is considered in accordance with the Law of the Republic of Uzbekistan “On Appeals of Individuals and Legal Entities”',
        individual: 'Individual',
        entrepreneur: 'Entrepreneur',
        anonimously: 'Anonumously',
      },

      personalData: 'Fill in your personal information',
      firstName: 'First name',
      lastName: 'Last name',
      phoneNumber: 'Phone number',
      email: 'Email',

      describeProblem: 'Describe your problem',
      requestTopic: 'Request topic',
      requestTopicDescription:
        'If you don`t find a suitable appeal topic, click "Other" and enter the topic yourself',
      city: 'City',
      requestMessage: 'Request message',

      companyInfo: 'Company information',
      companyName: 'Company name',
      companyNumber: 'TIN of the organization',

      anonimouslyDataTitle: 'Fill in the data (optional)',
      anonimouslyDataDescription:
        'If you would like to receive feedback but wish to remain anonymous, please provide an email address that does not contain your personal data',

      requestAppeal: 'Submit an appeal',
      leaveAppeal: 'Leave an appeal',
      checkStatus: 'Check request status',

      anonimouslyTopics: {
        participation: 'Participation in fraudulent schemes',
        internalPolicy: 'Violation of domestic policy',
        discrimination: 'Discrimination of employees',
        ignore: 'Ignoring conflicts of interest',
        other: 'Other',
      },

      describeList: {
        firstTitle: 'What happened?',
        firstDescription: 'I have a suspicion that....',
        secondTitle: 'Who was involved in the incident or violation? ',
        secondDescription: 'Indicate the level of engagement',
        thirdTitle: 'Where did it happen? ',
        thirdDescription: 'Specify city, region, exact address, branch name',
        fourthTitle: 'When it happened?',
        fourthDescription:
          'Indicate the time, date and frequency of the incident',
        fifthTitle: 'Upload your documents or photos.',
        fifthDescription:
          'If you have any documentation to support the incident, please upload it',
      },

      incidentLocation: 'Incident location',

      fileInputTitle: 'Add documents or files',
      mobileFileInputTitle: 'Upload documents or files',

      agreeWith: 'I agree with',
      rules: 'Rules of treatment',

      note1: 'By clicking the "I agree" button you agree with the rules',
      note2:
        ' "Procedure for Consideration of Appeals of Citizens and Clients of JSCB "TBC Bank" ',
      note3:
        'and declare that your application does not contain insults and/or other derogatory, false, defamatory information about the bank and its employees. Otherwise, the Bank has the right not to consider your application and to take measures against you established by law. By communicating information about third parties to the Bank, you warrant that you are the owner of such information and/or have proper authorization and bear all responsibility for dissemination of such information.',

      send: 'Send',
    },
    checkRequestForm: {
      title: 'Check request status',
      inputData: 'Enter data',
      inputDataDescription:
        'Enter 12-digit request ID. The request status will be sent to your email',
      requestID: 'Request ID',
      email: 'Email',
      send: 'Send',
    },
    locationsMap: {
      errorLoadingMap:
        'Error loading the map. Try refreshing the page or trying again later.',
      showMyLocation: 'Show my location',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      cap: {
        card: {
          office: 'Offce',
          metro: 'Metro',
          landmark: 'Landmark',
          photo: 'Photo',
          workingHours: {
            heading: 'Heading',
            dayOff: 'Day off',

            mondaySaturday: 'mon-sat',
            saturdaySunday: 'sat-sun',
            mondayFriday: 'mon-fri',
            mondaySunday: 'mon-sun',
            saturday: 'sat',
            sunday: 'sun',
          },
          getDirections: 'Get directions',
          copyAddress: 'Copy address',
        },
        status: {
          monday: 'monday',
          sunday: 'sunday',
          tomorrow: 'tomorrow',
          card: {
            open: 'Open',
            closed: 'Closed',
          },
          marker: {
            open: 'Open',
            closed: 'Closed',
          },
        },
      },
      search: {
        title: 'Search',
        placeholder: 'Input address or metro',
      },
    },
    search: {
      title: 'Search',
      popularRequests: 'Popular requests',
      notFound: 'Not found',
      tryAnother: 'Try other popular requests',
      placeholder: 'What do you want to find?',
    },
    faq: {
      title: 'What we can do to help?',
      listTitle: 'All topics and articles',
      readAll: 'Read all',
      placeholder: 'Input your request',
      frequentRequests: 'Frequent requests',
    },
    smsForm: {
      typeInNumber: 'Input number',
      send: 'send',
      sendAgain: 'Send again',
    },
    currencyRateBlock: {
      label: 'Currency rates',
      dollar: 'Dollar',
      euro: 'Euro',
      ruble: 'Ruble',
      checkAll: 'Check all',
      buy: 'Buy',
      sell: 'Sell',
    },
    currencySwapBlock: {
      sum: 'Sum',
      currency: 'Currency',
      sellingInput: {
        desktopHeading: 'I have',
        mobileLabel: 'I have',
      },
      buyingInput: {
        desktopHeading: 'I want to buy',
        mobileLabel: 'I will receive',
      },
      swapButtonLabel: 'Swap currencies',
      relevanceNotice: 'The rate is relevant at {date}',
    },
    currencyRateTableBlock: {
      heading: 'All currency rates',
      relevanceNotice:
        'The rate is relevant at {date}. The rate may change during the day.',
      code: 'Code',
      currency: 'Exchange currency',
      quantity: 'Units',
      sell: 'Sell',
      buy: 'Buy',
      cbuRate: 'CB rate',
      showAllRates: 'Show all currencies',
    },
    calculatorBlock: {
      chooseSum:
        'Select an amount from {minLimit} to {maxLimit} {currency} and a term of up to {n} months',
      text: 'For a deposit amount of {sum} with a term of {term}, you will receive {percent} annual interest with a final return of about {result}',
      keepPercent: 'Keep the interest',
      keepPercentDescription:
        'Each month we add interest to the principal amount of the deposit',
      replenishmentDeposit: 'Deposit replenishment',
      replenishmentDepositDescription:
        'Will be available at any time after the deposit is opened',
      withdrawal: 'Withdrawal',
      withdrawalDescription:
        'Will be available at any time after the deposit is opened',
      openDeposit: 'Open a deposit',
      months: '{n} month | {n} months',
      monthsMobile: '{n} m.',
      som: 'SOM',
      dollars: 'DOLLAR',
      schedule: {
        title: 'Deposit payment scheduleу',
        date: 'Date',
        amount: 'Deposit amount',
        percent: 'Accrued %',
        showAllLines: 'Show all lines',
        download: 'Download calendar',
        total: 'Total',
        month: '{n} month',
      },
    },
    creditCalculatorBlock: {
      chooseSum:
        'Open a DerositSelect an amount from {minLimit} to {maxLimit} {currency} and term up to {n} months',
      text: 'With a desired amount of {sum} {currency} for a term of {months} with a rate of {rate} the monthly payment will be approximately {result}',
      getCredit: 'Get a loan',
      months: '{n} month | {n} months',
    },
    creditCalculatorFormBlock: {
      label1: 'If you take a loan for the amount',
      label2: 'with a rate',
      label3: 'the monthly payment will be:',
      button: 'Submit an application',
      downloadInfoList: 'Download information sheet',
      max: 'max {n}',
      rate: 'rate',
      creditTerm: 'credit term',
      months: '{n} month | {n} months',
      years: '{n} year | {n} years',
    },
    tenderListBlock: {
      sort: 'Sort',
      year: '{n}th year',
      submissionDate: 'Submission of applications by {date}',
      asc: 'Old ones first',
      desc: 'New ones first',
    },
    tenderRequestForm: {
      label: 'Leave a request',
      firstName: 'First name',
      lastName: 'Last name',
      phoneNumber: 'Phone number',
      email: 'E-mail',
      extraInfo: 'Extra info',
      send: 'Send',
      agreements:
        'I agree to transfer my personal data contained in the questionnaire and all attached files. I understand and agree that my data will be stored and processed.',
      agreementsMobile: 'I agree with {rules}',
      rules: 'Rules of treatment',
      mustAgree: 'You must agree to the terms and conditions',
      personalData: 'Fill in your personal information',
    },
    depositCalculatorFormBlock: {
      label1: 'If you',
      label2: 'for a term',
      label3: 'and',
      label4: 'your income will be',
      open: 'Open {text}',
      max: 'max',
      keepPercent: 'Keep the interest',
      month: '{n} mon.',
      keepPercentDescription:
        'Each month we add interest to the principal amount of the deposit',
      replenishmentDeposit: 'Deposit replenishment',
      replenishmentDepositDescription:
        'Will be available at any time after the deposit is opened',
      withdrawal: 'Withdrawal',
      withdrawalDescription:
        'Will be available at any time after the deposit is opened',
      year: 'yearly',
      schedule: 'View payment schedule',
      tooltipCapitalization: {
        title: 'What does it mean to leave interest',
        description:
          'Each month we add interest to the principal amount of the deposit',
      },
      tooltipWithdrawal: {
        title: 'What does it mean to partially withdraw',
        description:
          'The deposit amount decreases, but interest is calculated based on the initial deposit amount.',
      },
    },
    blog: {
      readingTime: '{n} min read',
      openArticle: 'Open article',
      openTagArticles: 'Open tag articles',
      showAllTags: 'Show all tags',
      viewAllArticles: 'View all articles',
      allArticles: 'All articles',
      toHomePage: 'Back to blog',
      tagPageHeading: 'All articles by tag «{tag}»',
    },
    mediaPlayer: {
      play: 'Play',
      pause: 'Pause',
      mute: 'Mute',
      unmute: 'Unmute',
      fullscreen: 'Fullscreen mode',
      exitFullscreen: 'Exit fullscreen mode',
    },
    career: {
      vacancies: '{n} vacancies | {n} vacancy | {n} vacancies',
      allVacancies: 'All vacancies',
    },
    vacancies: {
      searchPlaceholder: 'Enter job title',
      area: 'Location',
      workExperience: 'Work experience',
      experience: 'Experience',
      categories: 'Categories',
      workExperienceOptions: {
        noExperience: 'No experience',
        between1And3: '1-3 years',
        between3And6: '3-6 years',
        moreThan6: 'More than 6 years',
      },
      workFormats: {
        hybrid: 'Hybrid',
        onsite: 'Onsite',
        remote: 'Remote',
        field: 'Field',
      },
      openVacancy: 'Open vacancy',
    },
    vacanciesBlock: {
      title: 'Vacancies',
      allCategories: 'All categories',
      showMoreVacancies: 'Show more vacancies',
    },
    mobileVacanciesBlock: {
      title: 'All vacancies\n at TBC UZ',
    },
    newsListBlock: {
      allNews: 'All news',
      asc: 'Old ones first',
      desc: 'New ones first',
    },
    NewsOtherArticlesBlock: {
      otherNews: 'Other news',
    },
    tags: 'Tags',
  },
};

export default defineI18nConfig(() => ({
  messages,
  pluralRules: {
    ru: function (choice, choicesLength) {
      if (choice === 0) {
        return 0;
      }

      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;

      if (choicesLength < 4) {
        return !teen && endsWithOne ? 1 : 2;
      }
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }

      return choicesLength < 4 ? 2 : 3;
    },
  },
}));
